import type { ReactNode } from "react";

export interface Column<T> {
  key: string;
  header: string;
  /** esconde a coluna em telas pequenas */
  hideOnMobile?: boolean;
  align?: "left" | "right";
  render: (row: T) => ReactNode;
}

export interface TableProps<T> {
  columns: Column<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  empty?: ReactNode;
}

/** Tabela padrão, responsiva por rolagem horizontal. */
export default function Table<T>({ columns, rows, rowKey, empty }: TableProps<T>) {
  if (rows.length === 0 && empty) return <>{empty}</>;

  return (
    <div className="-mx-5 overflow-x-auto px-5">
      <table className="w-full min-w-[560px] border-collapse text-sm">
        <thead>
          <tr className="border-b border-line/60 text-left">
            {columns.map((column) => (
              <th
                key={column.key}
                className={`py-2 pr-4 font-mono text-[11px] font-medium uppercase tracking-wide text-ink-muted ${
                  column.align === "right" ? "text-right" : ""
                } ${column.hideOnMobile ? "hidden md:table-cell" : ""}`}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)} className="border-b border-line/30 last:border-0">
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`py-3 pr-4 align-middle ${column.align === "right" ? "text-right" : ""} ${
                    column.hideOnMobile ? "hidden md:table-cell" : ""
                  }`}
                >
                  {column.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
